import ManipulatedOrderItemsTable from '../components/manipulated_order_items_table.vue'

export default {
  components: {
    ManipulatedOrderItemsTable
  }
}